<template>
  <kernel-chart-wrapper
    :tooltip-handler="tooltipHandler"
    title="Order statuses"
  >
    <template #default="{ options }">
      <v-bar
        :data="chartData"
        :legend-visible="false"
        :settings="chartSettings"
        :extend="options.chartExtend"
        :text-style="options.textStyle"
        :height="$attrs.loading ? 'auto' : '320px'"
        width="100%"
      />
    </template>
  </kernel-chart-wrapper>
</template>

<script>
import { mapState } from 'vuex';

import VBar from 'v-charts/lib/bar.common';

import { formatDate } from '@helpers';

import { namespace as DashboardNamespace } from '../store.types';

const titles = {
  activeCount: 'Active',
  holdCount: 'Hold',
  canceledCount: 'Canceled',
};

export default {
  name: 'KernelOrderStatusesChart',
  components: { VBar },
  computed: {
    ...mapState(DashboardNamespace, {
      chartData: ({ stats: { orderStatuses: stat } }) => ({
        columns: ['date', 'activeCount', 'holdCount', 'canceledCount'],
        rows: (stat || [])
          .map((v) => ({ ...v, date: formatDate(v.date, { dateFormat: 'dd MMM yyyy' }) })),
      }),
    }),
    chartSettings: () => ({
      stack: {
        statuses: ['activeCount', 'holdCount', 'canceledCount'],
      },
    }),
  },
  methods: {
    tooltipHandler: (values) => values.map((v) => ({ ...v, title: titles[v.title] })),
  },
};
</script>
